




















import { AppState } from "../shared/types/AppState";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Clickbutton from "@/components/Clickbutton.vue";
import Linkbutton from "@/components/Linkbutton.vue";
import Icon from "@/components/Icon.vue";

@Component(
{
	components: {
		Clickbutton,
		Linkbutton,
		Icon
	}
})

export default class TranslationsActionsPane extends Vue
{
	@Prop() state!: AppState;

	@Watch("state")
	onstateChanged(val: string)
	{
		(this as any).model.state = val;
	}

	data()
	{
		return {
			model: {
				state: this.state
			},
			AppState: AppState
		};
	}

	save(e: Event)
	{
		this.$emit("save", e);
	}

	discard(e: Event)
	{
		this.$emit("discard", e);
	}
}
